(function(){
  'use strict';
  // Click-through image arrows on product cards (homepage drop-grid + collection grids).
  // Images are loaded on demand (only when an arrow is clicked), not upfront.
  document.addEventListener('click', function(e){
    var arrow = e.target.closest('[data-card-prev],[data-card-next]');
    if(!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var container = arrow.closest('.product-img-wrap, .coll-card-img');
    if(!container) return;
    var img = container.querySelector('[data-card-img]');
    if(!img || !img.dataset.images) return;
    var imgs = img.dataset.images.split('|');
    if(imgs.length < 2) return;
    var dir = arrow.hasAttribute('data-card-next') ? 1 : -1;
    var idx = (parseInt(img.dataset.idx || '0', 10) + dir + imgs.length) % imgs.length;
    img.dataset.idx = idx;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = imgs[idx];
  });
})();
